import React from 'react';
import GameContext from './gameContext';
import BODY_BASE from "../assets/hpa-base.png";
import DEFAULT_AXIS from "../assets/hpa-default.png";

export const Axis = () => {
  const gameContext = React.useContext(GameContext);

  const getOverlays = () => {
    const overlays = [];

    // THE ORDER MATTERS
    Object.keys(gameContext.axis).forEach((key, index) => {
      const axis = gameContext.axis[`${key}`];
      if (axis.count) {
        const overlay = <img className="axis-img-overlay" src={axis.overlay}
          alt={axis.alt} key={`${axis.overlay}${index}`}/>;
        overlays.push(overlay);
      }
    });
    return overlays;
  }

  return (
    <div id="axis">
      <div className="body-img-container" data-testid="axis">
        <img className="body-img" src={BODY_BASE} alt="HPA Axis"/>
        <img className="axis-img-overlay" src={DEFAULT_AXIS} alt=""/>
        {getOverlays()}
      </div>
    </div>
  )
}